exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html.dark .ds-lbl{color:rgba(214,228,240,.4)}html.dark .ds-lbl b{color:#d6e4f0}html.dark .ds-slider{background:hsla(0,0%,100%,.12);accent-color:#a5a8e8}", ""]);

// exports
